import {ResultScreen} from '@shared/SupportModal/ResultScreen/ResultsScreen';
import {PropsWithChildren} from 'react';

import {useFormErrorMessages} from '@utils/hooks/useFormErrorMessages';

import {FormSubmissionState} from './types';

type Props = {
  formState: FormSubmissionState;
  successMessages: {
    title: string;
    description?: string;
  };
  buttonText?: string;
  handleButtonClick?: () => void;
};

/** for 'initial' state renders children, otherwise renders success/error state */
export const FormContentOrResultView = ({
  formState,
  children,
  successMessages,
  buttonText,
  handleButtonClick,
}: PropsWithChildren<Props>) => {
  const errorMessages = useFormErrorMessages();

  switch (formState) {
    case 'error':
      return (
        <ResultScreen
          variant="error"
          button={buttonText}
          handleButtonClick={handleButtonClick}
          {...errorMessages}
        />
      );

    case 'success':
      return (
        <ResultScreen
          variant="success"
          button={buttonText}
          handleButtonClick={handleButtonClick}
          {...successMessages}
        />
      );

    default:
      return children;
  }
};
